import React, { useEffect, useState } from "react";
import axios from "axios";
import { useOutletContext } from "react-router-dom";
import { FaPlus, FaTrash } from "react-icons/fa";
import "../../styles/circuitoDesignSystem.css";

export default function CircuitoPatrocinadoresPainel() {
  const { circuito } = useOutletContext();
  const [patrocinadores, setPatrocinadores] = useState([]);
  const [loading, setLoading] = useState(false);

  // Form
  const [nome, setNome] = useState("");
  const [linkExterno, setLinkExterno] = useState("");
  const [imagem, setImagem] = useState(null);

  useEffect(() => {
    if (circuito?._id) buscarPatrocinadores();
  }, [circuito]);

  const buscarPatrocinadores = async () => {
    const res = await axios.get(`https://api.ticketdovaqueiro.com/api/circuitos/${circuito._id}/patrocinadores/painel`);
    setPatrocinadores(res.data);
  };

  const handleSalvar = async (e) => {
    e.preventDefault();
    if (!nome || !imagem) return alert("Nome e Imagem são obrigatórios!");
    
    setLoading(true);
    const formData = new FormData();
    formData.append("nome", nome);
    formData.append("linkExterno", linkExterno);
    formData.append("imagem", imagem);

    try {
      await axios.post(`https://api.ticketdovaqueiro.com/api/circuitos/${circuito._id}/patrocinadores`, formData);
      setNome(""); setLinkExterno(""); setImagem(null);
      buscarPatrocinadores();
    } catch (err) {
      alert("Erro ao salvar patrocinador");
    } finally {
      setLoading(false);
    }
  };

  const deletarPatrocinador = async (id) => {
    if (!window.confirm("Deseja remover este patrocinador?")) return;
    await axios.delete(`https://api.ticketdovaqueiro.com/api/circuitos/${circuito._id}/patrocinadores/${id}`);
    buscarPatrocinadores();
  };

  return (
    <div className="pc-page-header">
      <h1 className="pc-page-header__title">Patrocinadores</h1>
      <p className="pc-page-header__subtitle">Gerencie os banners de parceiros na página inicial</p>

      <form onSubmit={handleSalvar} className="pc-card" style={{ marginTop: 24, display: "grid", gap: 16 }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
          <div>
            <label style={{ display: "block", marginBottom: 8, fontSize: 14 }}>Nome da Empresa/Patrocinador *</label>
            <input type="text" value={nome} onChange={e => setNome(e.target.value)} className="c-input" required style={{ width: "100%", height: 44, paddingLeft: 16 }} />
          </div>
          <div>
            <label style={{ display: "block", marginBottom: 8, fontSize: 14 }}>Link (Site ou Instagram Opcional)</label>
            <input type="text" placeholder="https://" value={linkExterno} onChange={e => setLinkExterno(e.target.value)} className="c-input" style={{ width: "100%", height: 44, paddingLeft: 16 }} />
          </div>
        </div>
        <div>
          <label style={{ display: "block", marginBottom: 8, fontSize: 14 }}>Banner do Patrocinador (Formato Horizontal Retangular) *</label>
          <input type="file" accept="image/*" onChange={e => setImagem(e.target.files[0])} className="c-input" required style={{ width: "100%", height: 44, padding: "10px 16px" }} />
        </div>
        <button type="submit" disabled={loading} className="c-btn c-btn--primary" style={{ height: 44, width: 200 }}>
          {loading ? "Salvando..." : <><FaPlus /> Adicionar Patrocinador</>}
        </button>
      </form>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: 16, marginTop: 24 }}>
        {patrocinadores.map(p => (
          <div key={p._id} className="pc-card" style={{ padding: 16, position: "relative" }}>
            <img src={`https://api.ticketdovaqueiro.com/uploads/${p.imagem}`} alt={p.nome} style={{ width: "100%", borderRadius: 8, height: 100, objectFit: "cover", marginBottom: 12 }} />
            <h3 style={{ fontSize: 16, margin: 0, color: "#fff" }}>{p.nome}</h3>
            <button onClick={() => deletarPatrocinador(p._id)} style={{ position: "absolute", top: 8, right: 8, background: "#ef4444", color: "#fff", border: "none", width: 30, height: 30, borderRadius: 6, cursor: "pointer" }}>
              <FaTrash />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}